import { isMobileBrowser } from './../../models/mobile.browser';
import { VideoAdapter } from './../../models/video.adapter';
import {Component, HostListener} from '@angular/core';
import { NavController, AlertController, PopoverController, NavParams, ModalController } from 'ionic-angular';
import {NgZone} from '@angular/core';
import { DecimalPipe } from '@angular/common';
import videojs from 'video.js';

import { Storage } from '@ionic/storage';

export enum KEY_CODE {
  SHIFT = 16, // regardless of left or right shift
  SPACE = 32,
  ARROW_LEFT = 37,
  ARROW_UP = 38,
  ARROW_RIGHT = 39,
  ARROW_DOWN = 40,
  KEY_S = "KeyS",
  KEY_M = "KeyM",
  KEY_B = "KeyB",
  KEY_T = "KeyT",
}

export enum KEY {
  META = "Meta", // eg CMD on Mac, WIN on Windows; cannot be identified by key code because left and right are different
  DELETE = "Delete",
  BACKSPACE = "Backspace",
  ENTER = "Enter",
  ESCAPE = "Escape",
  ALT = "Alt",
  CONTROL = "Control",
}

declare var annyang;
declare var MediaRecorder;

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  is_mobile;

  config_source = ""
  // config_source = "https://s3.eu-central-1.amazonaws.com/salsa-loca-assets/choreo_video/pablo_y_raquel_jesse_joy_config.txt"
  // // does not work because we are not allowed to reqire this file
  // config_source = "file:///Users/florianwetschoreck/Movies/bachata_trainer/pablo_y_raquel_jesse_joy_config.txt"

  // config = {
  //   id: "Pablo y Raquel - Jesse Joy.mp4",
  //   video: {
  //     name: "Pablo y Raquel - Jesse Joy", // the local config for this video.name will tried to be restored if no other config is set
  //     source: "file:///Users/florianwetschoreck/Movies/bachata_trainer/Pablo y Raquel - jesse Joy corre bachata Sensual con Pablo y Raquel  workshop en stuttgart bachata festival 2018.mp4",
  //     beats: [],
  //     mean_beat_length: 0.508,
  //     beat_offset_ms: 200,
  //     sections: [
  //       // {
  //       //   name: "Unnamed",
  //       //   start_time: 47.93,
  //       //   end_time: 51.994,
  //       // },
  //     ],
  //     player: "local",
  //   },
  //   publisher: {
  //     name: "Anna Navarro"
  //   },
  //   user: {
  //     name: "Anna Navarro",
  //     subtitle: "Lady Team"
  //   },
  //   app: {
  //     language: {},
  //     version: {},
  //   },
  // }


  // <!--src="file:///Users/florianwetschoreck/Movies/Ivan_And_Saray_Bachata_great_inspiration.mp4"-->
  // <!--src="file:///Users/florianwetschoreck/Movies/Cornel_Rhitika_Handbrake.mp4"-->
  // <!--src="file:///Users/florianwetschoreck/Downloads/Chris_7thMay.mp4"-->
  // <!--src="https://www.w3schools.com/html/mov_bbb.mp4"-->
  // source = "file:///Users/florianwetschoreck/Movies/Cornel_Rhitika_Handbrake.mp4"

  // source = "file:///Users/florianwetschoreck/Movies/bachata_trainer/Pablo y Raquel - jesse Joy corre bachata Sensual con Pablo y Raquel  workshop en stuttgart bachata festival 2018.mp4"
  // video_name = "PabloyRaquel.mp4"
  // video_name = "PabloyRaqueljlkjkklkllkllkjkljljljklklkllkjkljlkj.mp4"

  // source = "https://s3.eu-central-1.amazonaws.com/salsa-loca-assets/choreo_video/PabloyRaquel.mp4"
  // video_name = "PabloyRaquel.mp4"



  // source = ""
  // video_name = ""

  DEFAULT_CONFIG = {
    id: "",
    video: {
      type: 'youtube', // youtube, url, local
      youtube_id: '',
      source: "", // might be remote URL on a web server (or a local file if I test something and access via file:// protocol)
      name: "",
      beats: [], // should be calculated based on on1_indicators, mean_beat_length and beat_offset_ms
      mean_beat_length: 0.508,
      beat_offset_ms: 200,
      duration: null,
      on1_indicators: [],
      sections: [],
    },
  }

  config = this.DEFAULT_CONFIG;
  configImportElement;

  user_video;

  BEFORE_CURRENT_TIME = 'BEFORE_CURRENT_TIME'
  AFTER_CURRENT_TIME = 'AFTER_CURRENT_TIME'

  BEFORE_CURRENT_SECTION = 'BEFORE_CURRENT_SECTION'
  AFTER_CURRENT_SECTION = 'AFTER_CURRENT_SECTION'

  LEFT = 'left'
  RIGHT = 'right'

  SECTION_DEFAULT_NAME = "Unnamed";
  SECTION_MAX_BEAT_LENGTH = 44;
  SECTION_NEW_DEFAULT_BEAT_LENGTH = 8;
  SECTION_BEAT_LENGTH_AFTER_ENTER = 16;
  SECTION_MIN_KNOB = 1;

  LOOP_MODE_FULL_VIDEO = 'full_video';
  LOOP_MODE_SINGLE_SECTION = 'single_section';
  LOOP_MODE_MULTIPLE_SECTIONS = 'multiple_sections';

  SEEKER_ACCURACY = 100; // those are steps which can be chosen

  TIME_ACCURACY_EPSILON = 0.1;

  BEAT_SOUND_1 = new Audio('assets/voice/BEAT_SOUND_1.mp3');
  BEAT_SOUND_2 = new Audio('assets/voice/BEAT_SOUND_2.mp3');
  BEAT_SOUND_3 = new Audio('assets/voice/BEAT_SOUND_3.mp3');
  BEAT_SOUND_4 = new Audio('assets/voice/BEAT_SOUND_4.mp3');
  BEAT_SOUND_5 = new Audio('assets/voice/BEAT_SOUND_5.mp3');
  BEAT_SOUND_6 = new Audio('assets/voice/BEAT_SOUND_6.mp3');
  BEAT_SOUND_7 = new Audio('assets/voice/BEAT_SOUND_7.mp3');
  BEAT_SOUND_8 = new Audio('assets/voice/BEAT_SOUND_8.mp3');

  keyboard_shortcuts_enabled = true;

  seeker;

  limit_range = {
    upper_anchor_time: 0,
    section_limits: {
      lower: 1,
      upper: 2
    },
  }

  loop_mode = this.LOOP_MODE_FULL_VIDEO;
  looping = false; // this is actually just "current_section" valid or not
  loop_start_time;
  loop_end_time;
  loop_enabled = true;

  active_section_index = -1;
  current_section;

  big_loop_section_index = -1;
  big_loop_section;

  video_player;
  video_source;
  speed = 1.0;
  video_monitoring_interval;

  videojs_player;
  show_videojs_player = false;

  youtube_player;
  show_youtube_player = false;

  _window;
  yt_player;
  youtube_video_id;
  bodyFocusInterval;

  beat_indicators = [];
  // those work for saray and ivan
  // beat_indicators = [8.243245, 8.520668, 9.137773, 9.69746, 10.274239, 10.785772, 11.297847, 11.749342, 12.258615, 12.779276, 13.271637, 13.770574, 14.280017, 14.751011, 15.242524, 15.674648, 68.224523]
  // those work for cornell and rhitika
  // beat_indicators = [60.28682, 60.741409, 61.239827, 61.739208, 62.297268, 62.740714, 63.227722, 63.730492, 64.256557, 64.813107, 65.325605, 65.816722, 66.366873, 66.906647, 67.408842, 67.802618, 133.461524];
  beat_indicator_buffer = [];
  buffer_timeout;

  TACT_TYPE_COLLECTION = {
    'to4': {
      name: 'to4',
      label: '1234',
      counts_per_tact: 4,
      tacts_per_count_set: 1,
    },
    'bachata': {
      name: 'bachata',
      label: '1234, 5678',
      counts_per_tact: 4,
      tacts_per_count_set: 2,
    },
    'waltz1': {
      name: 'waltz1',
      label: '123',
      counts_per_tact: 3,
      tacts_per_count_set: 1,
    },
    'waltz2': {
      name: 'waltz2',
      label: '123, 456',
      counts_per_tact: 3,
      tacts_per_count_set: 2,
    },
  }

  tact_type = this.TACT_TYPE_COLLECTION['bachata'];
  tact_show_syncopations = false;

  current_beat = {
    time: 0,
    count: 1,
  };
  last_beat = {
    time: 0,
    count: 1,
  };
  show_beat_count_header_left = true;


  show_advanced_navbar = false;
  show_speed_navbar = false;
  show_tutorial_navbar = false;
  show_config_navbar = false;
  show_record_player = false;
  show_tact_menu = false;
  show_tact_menu_advanced = false;

  show_laptop_nudge = true;

  // show_settings = true;
  show_settings = false;

  delete_sections_alert = false;
  mirror_video = false;
  play_count_sounds = false;
  add_new_section_in_background = false;
  show_tact_type_selection = false;

  // feature flags
  voice_feature_flag = false;

  shift_down = false;
  ctrl_down = false; // currently, it is never used because it interferes with Mac system shortcuts
  alt_down = false;


  constraints = {
    audio: true, // if "true": during recording this will lead to inference if the record player is not muted
    video: {
      width: 1280, height: 720
    }
  };

  record_player;
  record_player_is_paused;
  mediaSource;
  mediaRecorder;
  recordedBlobs;
  sourceBuffer;
  recordStartTime;
  isRecording = false;
  userStream;
  userStreamIsShown = true;
  recording_is_initialized = false;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public zone: NgZone,
              public storage: Storage,
              public decimalPipe: DecimalPipe,
              public alertCtrl: AlertController,
              public popoverController: PopoverController,
              public modalCtrl: ModalController) {
    this.is_mobile = isMobileBrowser();
    this.user_video = this.navParams.get('video');
    // this.tryToLoadConfig();
    try {
      this.mediaSource = new MediaSource();
    } catch(error){
      console.log("mediaSource is not available.")
    }

  }

  setupVideo(){
    this.resetPageState();
    if(this.user_video){
      this.setupUserVideo()
    } else {
      this.setupDefaultVideo()
    }
  }

  resetPageState(){
    if(this.video_player){
      this.setSpeed(1);
      this.pauseVideo();
      this.selectFullVideo();
      this.video_player.tearDown();
    }

    this.show_youtube_player = false;
    this.show_videojs_player = false;
    this.mirror_video = false;
    this.stopVideoMonitoring();
    this.maybeResetRecordingState();
    this.resetTact(false);
  }

  maybeResetRecordingState(){
    if(this.record_player){
      this.hideRecording()
      this.recordedBlobs = null;
      this.recordStartTime = null;
    }
  }

  setupUserVideo(){
    if(this.user_video.type == "youtube"){
      this.setupYTPlayer();
    } else if(this.user_video.type == "local") {
      this.setupVideoJSVideoPlayer({ type: this.user_video.file_type, src: this.user_video.fileURL });
    }
    this.addUserVideoInfoToConfig()
  }

  addUserVideoInfoToConfig(){
    this.config.video.type = this.user_video.type;
    if(this.user_video.type == "youtube") {
      this.config.video.youtube_id = this.user_video.youtube_id;
    }
    this.updateConfig(this.config);
  }

  setupDefaultVideo(){
    this.initVideoJSVideoPlayer('assets/video/PyR.mp4')
  }

  ionViewDidLoad() {
    this.setupVideo();
    this.initRecordPlayer();
    // this.setupDefaultVideo();

    if(this.voice_feature_flag && annyang) this.initializeVoiceControl();

    this.maybeStartFocusToBodyInterval()
  }

  // the youtube player iFrame catches focus and then the arrow keys use the youtube behavior and not ours
  // https://stackoverflow.com/questions/29477263/cant-change-focus-from-youtube-iframe
  maybeStartFocusToBodyInterval(){
    if(!this.bodyFocusInterval){
      document.body.tabIndex = -1; // this makes any element focusable
      let body = document.body;

      this.bodyFocusInterval = setInterval(() => {
        // console.log("focus")
        body.focus();
      }, 100);
    }
  }

  stopFocusToBodyInterval(){
    clearInterval(this.bodyFocusInterval);
    this.bodyFocusInterval = null;
  }

  initializeVoiceControl(){
    let commands = {
      // 'hello *': function() { alert('Hello'); },

      'please restart *': () => { this.maybeRestartLoop() },
      'Siri restart *': () => { this.maybeRestartLoop() },
      'restart *': () => { this.maybeRestartLoop() },
      'we are': () => { this.maybeRestartLoop() }, // sometimes confused with restart

      'play *': () => { this.playVideo() },
      'start *': () => { this.playVideo() },
      'pause *': () => { this.pauseVideoOrStopRecording() },
      'stop *': () => { this.pauseVideoOrStopRecording() },

      'record *': () => { this.startRecording() },

      'faster *': () => { this.increaseSpeed() },
      'Fester *': () => { this.increaseSpeed() },
      'Festa *': () => { this.increaseSpeed() },
      'play faster *': () => { this.increaseSpeed() },

      'slower *': () => { this.decreaseSpeed() },
      'lower *': () => { this.decreaseSpeed() },
      'flower *': () => { this.decreaseSpeed() },
      'play slower *': () => { this.increaseSpeed() },

      'music off *': () => { this.video_player.setMute(true) },
      'mute *': () => { this.video_player.setMute(true) },
      'music on *': () => { this.video_player.setMute(false) },
      'unmute *': () => { this.video_player.setMute(true) },

      'next section': () => { this.selectNextSection(); },

      'previous section': () => { this.selectPreviousSection(); },
      'who is section': () => { this.selectPreviousSection(); },

      'mirror *': () => { this.mirror_video = !this.mirror_video },

      'play sounds *': () => { this.play_count_sounds = true },
      'play songs *': () => { this.play_count_sounds = true },
      'stop sounds *': () => { this.play_count_sounds = false },
      'stop songs *': () => { this.play_count_sounds = false },

      // those are not well recognized
      'stop loop *': () => { this.disableLoop() },
      'quit loop *': () => { this.disableLoop() },
      'quit lube *': () => { this.disableLoop() },
    };

    annyang.addCommands(commands);
    // annyang.setLanguage('de-DE'); // https://github.com/TalAter/annyang/blob/master/docs/FAQ.md#what-languages-are-supported
    annyang.start({ autoRestart: true, continuous: false }); // for faster detection
    annyang.debug();
  }

  maybeRestartLoop(){
    if(this.loop_mode == this.LOOP_MODE_SINGLE_SECTION || this.loop_mode == this.LOOP_MODE_MULTIPLE_SECTIONS){
      this.seekToLoopStart();
    }
  }

  tryToLoadConfig(){
    if(this.config_source){
      this.loadConfigFromWebserver();
    } else if(this.config){
      this.loadInlineConfig();
    }
    // else {
    //   this.tryToLoadConfigFromStorageOrReset(this.config_default_name);
    // }
  }

  loadInlineConfig(){
    this.video_source = this.config.video.source;
  }

  loadConfigFromWebserver(){
    var request = new XMLHttpRequest();
    request.open('GET', this.config_source, true);
    request.send(null);
    request.onreadystatechange = () => {
      if (request.readyState === 4 && request.status === 200) {
        var type = request.getResponseHeader('Content-Type');
        if (type.indexOf("text") !== 1) {
          this.updateConfig(JSON.parse(request.responseText))
          // console.log("loadConfigFromWebserver", this.config);
        }
      }
    }
  }

  download(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  downloadConfigFile(){
    let config = JSON.parse(JSON.stringify(this.config, null, 2))

    if(config.video.on1_indicators.length >= 2){
      // we dont want to save beats but the on1_indicators
      // if we have a beat but no on1_indicators, we will save the beat
      config.video.beats = [];
    }

    let duration = this.video_player.getDuration();
    if(duration){
      config.video.duration = duration;
    } else if(!config.video.duration){
      config.video.duration = null;
    }

    this.download(config.video.name + ".ldance", JSON.stringify(config, null, 2));
  }

  importFullConfig(event){
    // console.log("importFullConfig", event);
    // console.log("configImportElement", this.configImportElement);
    let file = event.srcElement.files[0];
    if(file){
      let reader = new FileReader();
      reader.onload = (event) => {
        let config = JSON.parse(event["target"]["result"])
        // console.log("####### read config:", config);
        if(config.video.sections.length > 0) this.config.video.sections = JSON.parse(JSON.stringify(config.video.sections));

        if(config.video.mean_beat_length){
          this.config.video.mean_beat_length = JSON.parse(JSON.stringify(config.video.mean_beat_length))
        }

        if(config.video.beat_offset_ms){
          this.config.video.beat_offset_ms = JSON.parse(JSON.stringify(config.video.beat_offset_ms))
        }

        if(config.video.on1_indicators){
          this.config.video.on1_indicators = JSON.parse(JSON.stringify(config.video.on1_indicators));
        } else {
          this.config.video.on1_indicators = [];
        }

        if(config.video.beats.length > 0){
          this.config.video.beats = JSON.parse(JSON.stringify(config.video.beats));
        }
        this.maybeCalibrateBeats();
        this.saveConfig();
        this.configImportElement = null; // this allows to import multiple times the same file

      };
      reader.readAsText(file);
    }
  }

  importConfigSections(event){
    let file = event.srcElement.files[0];
    if(file){
      let reader = new FileReader();
      reader.onload = (event) => {
        let config = JSON.parse(event["target"]["result"])
        // console.log("read config:", config);
        let new_sections = config.video.sections;
        this.config.video.sections = this.config.video.sections.concat(new_sections);
        // console.log(this.config.video.sections.concat(new_sections))
        this.saveConfig();
      };
      reader.readAsText(file);
    }
  }

  selectNewVideoModal() {
    let selectionModal = this.modalCtrl.create("ImportPage", { isModal: true });
    selectionModal.onDidDismiss(data => {
      this.disableKeyboardInput();
      if(data){
        this.user_video = data.video;
        this.setupVideo();
      } else {
        // console.log("user did cancel the modal")
      }
    });
    this.enableKeyboardInput();
    selectionModal.present();
  }

  selectedFile(event){
    // https://stackoverflow.com/questions/8885701/play-local-hard-drive-video-file-with-html5-video-tag
    let file = event.srcElement.files[0]
    let fileURL = URL.createObjectURL(file);

    // this.config.video.name = file.name.replace(/\.[^/.]+$/, ""); // without file extension
    this.tryToLoadConfigFromStorageOrReset(file.name, false);
    // console.log("selectedFile src", { type: file.type, src: fileURL });
    this.video_player.src({ type: file.type, src: fileURL });
    this.selectFullVideo();
    this.playVideo();
  }

  loadYoutubeUserVideoConfig(){
    if(this.user_video.overwrite_config){
      this.updateConfig(this.user_video.config);
      this.maybeCalibrateBeats();
    } else {
      this.tryToLoadConfigFromStorageOrReset(this.user_video.youtube_id);
    }
  }

  tryToLoadConfigFromStorageOrReset(config_id, set_video_source=true){
    // console.log("tryToLoadConfigFromStorageOrReset: ", config_id)
    this.storage.get(config_id).then((config) => {
      if(config){
        // console.log("loaded config from Storage: ", config)
        this.updateConfig(config);
        if(set_video_source) this.video_source = this.config.video.source; // we need this for remote or local files but not when selecting from local file system
        this.maybeCalibrateBeats();
      } else {
        // console.log("could not find local config for video_name: ", config_id)
        this.resetConfig(config_id);
      }
    });
  }

  updateConfig(new_config){
    // console.log("updateConfig", new_config);
    // console.log("updateConfig beats", new_config.video.beats);
    this.config = JSON.parse(JSON.stringify(new_config));
    // // if the beat config contains half counts, then we need to reflect this in the settings that we do (not) show them?
    // this triggers a recalibrate via the change of the model
    let has_1and_beat = this.config.video.beats.find((beat) => {
      return ("" + beat.count).includes("&");
    });
    // console.log("has_1and_beat", has_1and_beat);
    this.tact_show_syncopations = Boolean(has_1and_beat);
  }

  resetConfig(config_name){
    this.updateConfig(JSON.parse(JSON.stringify(this.DEFAULT_CONFIG))); // dont pass reference because then the default will be overwritten for every future change
    if(config_name) this.config.id = config_name;
    if(this.user_video) this.config.video.name = this.user_video.name;
    this.saveConfig();
  }

  saveConfig(){
    this.safelySortSections();
    this.storage.set(this.config.id, this.config);
    // console.log("saved config: ", this.config);
    // console.log("saved beats: ", this.config.video.beats);
  }

  initRecordPlayer(){
    try {
      let record_player = document.getElementById('record_player');
      let record_player_options = {
        controlBar: {
          volumePanel: false,
          muteToggle: false,
          // children: [
          //     "playToggle",
          //     "durationDisplay",
          //     "timeDivider",
          //     "currentTimeDisplay",
          //     "progressControl",
          //     "remainingTimeDisplay",
          //     "fullscreenToggle"
          // ]
        }
      };
      this.record_player = new VideoAdapter(videojs(record_player, record_player_options, () => { }), VideoAdapter.VIDEO_JS)
      this.record_player.player.controlBar.playToggle.on('click', () => {
        this.toggleRecording()
      })
      // // those listeners are just to make sure, that we never fuck up the record_player_is_paused state
      // // but they were actually out of sync and therefore, fucked it up :D
      // this.record_player.player.on('play', () => {
        // console.log("record_player - play", this.record_player.player.tech().el().paused);
      //   this.record_player_is_paused = false
      // })
      // this.record_player.player.on('pause', () => {
        // console.log("record_player - pause", this.record_player.player.tech().el().paused);
      //   this.record_player_is_paused = true;
      // })
    }
    catch(e){
      alert("We couldnt initialize the record player.")
    }
  }

  setupVideoJSVideoPlayer(src){
    if(this.videojs_player){
      this.video_player = new VideoAdapter(this.videojs_player, VideoAdapter.VIDEO_JS)
      this.video_player.src(src)
      this.video_player.player.one("canplay", () => {
        this.playVideo()
      })
      this.initVideoCallbacks();
      this.show_youtube_player = false;
      this.show_videojs_player = true;
    } else {
      this.initVideoJSVideoPlayer(src);
    }
    this.tryToLoadConfigFromStorageOrReset(this.user_video.name);
  }

  initVideoJSVideoPlayer(src) {
    // console.log("initVideoJSVideoPlayer", src);
    try {
      let video_player = document.getElementById('video_player');
      let video_player_options = {
        // controlBar: {
        //   children: [ // possibility to change the order of the children :)
        //     "playToggle",
        //     "durationDisplay",
        //     "timeDivider",
        //     "currentTimeDisplay",
        //     "progressControl",
        //     "remainingTimeDisplay",
        //     "fullscreenToggle",
        //   ]
        // }
      };
      this.videojs_player = videojs(video_player, video_player_options, () => { });
      this.video_player = new VideoAdapter(this.videojs_player, VideoAdapter.VIDEO_JS)
      // this.video_player.src('assets/video/PyR.mp4')
      this.video_player.src('assets/video/dummy.mp4')
      // there is a VideoJS bug that we cannot directly src our file object??
      // this.video_player.src(src);
      this.video_player.player.one("canplay", () => {
        this.playVideo()
        this.video_player.src(src); // src the actual video
        this.video_player.player.one("canplay", () => {
          this.show_videojs_player = true;
          this.playVideo()
        });
      })

      this.video_player.player.controlBar.playToggle.on('click', () => {
        this.toggleVideo();
      })

      this.initVideoCallbacks();
    }
    catch (e) {
      alert("We couldnt initialize the videojs player.")
    }
  }

  loadNewYoutubeVideo(){
    this.video_player.src(this.youtube_video_id);
  }

  setupYTPlayer(){
    if(this.youtube_player){
      this.video_player = new VideoAdapter(this.youtube_player, VideoAdapter.YOUTUBE);
      this.video_player.src(this.user_video.youtube_id);
      this.initVideoCallbacks();
      this.show_youtube_player = true;
      this.show_videojs_player = false;
    } else {
      this.initYTPlayer()
    }
    this.loadYoutubeUserVideoConfig();
  }

  initYTPlayer(){
    this.show_youtube_player = true;

    let doc = window.document;
    let playerApi = doc.createElement('script');
    playerApi.type = 'text/javascript';
    playerApi.src = 'https://www.youtube.com/iframe_api';
    doc.body.appendChild(playerApi);

    this._window = window;
    this.initVideoEventListener();

    this.createYTPlayer()
  }

  createYTPlayer(){
    let detect_YT_player_interval = setInterval(() => {
      if ((typeof this._window.YT !== 'undefined') && this._window.YT && this._window.YT.Player) {
        this.youtube_player = new this._window.YT.Player('ytplayer', {
          // videoId: 'M7lc1UVf-VE',
          // videoId: 'DeYUtM5kZJY', // pablo y raquel
          width: '100%',
          height: '100%',
          playerVars: {
            iv_load_policy: '3', // does not show comments
            rel: '0', // show related figure? 0-no; 1-yes
            // start: 60,
            // end: 2,
            autoplay: 1, // activates autoplay
            // controls: 0, // removes all controls
            fs: 1, // full screen button, hide:0, show:1
            showinfo: 0, // removes the title
            modestbranding: 1, // reduces the youtube branding
            playsinline: 1,
          },
          events: {
            onReady: (event) => {
              // console.log('YTonReady');
              this.onYoutubePlayerReady(event);
            },
            onStateChange: (event) => {
              // console.log('YTonStateChange');
              this.video_player.onStateChange(event);
            }
          }
        });
        this.video_player = new VideoAdapter(this.youtube_player, VideoAdapter.YOUTUBE);
        clearInterval(detect_YT_player_interval);
      }
    }, 100);
  }

  onYoutubePlayerReady(event){
    // console.log("onYoutubePlayerReady", event)
    this.video_player.src(this.user_video.youtube_id);
    // this.video_player.src('DeYUtM5kZJY'); // Pablo y Raqel - with ads - which disappear by AdBlocker
    // this.video_player.src('M7lc1UVf-VE'); // Youtube sample video without ads
    this.initVideoCallbacks();
  }

  initVideoEventListener(){
    // let div = document.getElementById('youtube-player-wrapper-div');
    // div.addEventListener("keypress", e => alert(`Capturing: ${e}`), true);
    // div.addEventListener("keydown", e => alert(`Capturing: ${e}`), true);
    // div.addEventListener("keyup", e => alert(`Capturing: ${e}`), true);
    // div.addEventListener("click", e => alert(`Capturing: ${e}`), true);
    // debugger;
  }

  initVideoCallbacks(){
    this.video_player.onplay(() => {
      // console.log("video.onplay")
      this.maybeEnableOrDisableLoop();
      this.startVideoMonitoring();
    });

    this.video_player.onpause(() => {
      // console.log("video.onpause")
      this.maybeEnableOrDisableLoop();
      this.stopVideoMonitoring();
    });

    this.video_player.onseeked(() => {
      // console.log("onseeked");
      // this.maybeShowCurrentSection();
      if(this.loop_mode == this.LOOP_MODE_SINGLE_SECTION){
        this.maybeEnableOrDisableLoop();
        this.maybeSelectFullVideoWhenUserSeekedWithVideoSeekerOutOfLoopRange();
      }

      // responsibility of this function is to update UI when video is paused
      // console.log("video.ontimeupdate")

      // the condition prevents interference with the monitoring interval when the video plays
      if(this.video_player.isPaused()){
        let currentTime = this.video_player.getCurrentTime();
        this.maybeUpdateBeatCountDisplay(currentTime);
        if(this.looping){
          this.setSeekerTime(currentTime);
        }
      }
    });
  }

  maybeSelectFullVideoWhenUserSeekedWithVideoSeekerOutOfLoopRange(){
    let below_limit_range = this.video_player.getCurrentTime() < this.limit_range.upper_anchor_time - this.SECTION_MAX_BEAT_LENGTH*this.config.video.mean_beat_length
    let above_limit_range = this.video_player.getCurrentTime() > this.limit_range.upper_anchor_time
    if(below_limit_range || above_limit_range){
      this.selectFullVideo();
    }
  }

  selectFullVideoClick(event){
    event.stopPropagation();
    this.selectFullVideo();
  }

  selectFullVideo(){
    // console.log("selectFullVideo")
    this.active_section_index = -1;
    this.looping = false;
    this.loop_mode = this.LOOP_MODE_FULL_VIDEO;
    // this.playVideo();
    // this.pauseVideo();
  }

  getLimitRangeKnob(knob_time){
    let time_diff = this.limit_range.upper_anchor_time - knob_time // eg 5
    let knob_diff = Math.round(time_diff / this.config.video.mean_beat_length) // eg 10
    let knob = this.SECTION_MAX_BEAT_LENGTH - knob_diff // eg 44-10 = 34
    return knob;
  }

  knobCanBeShown(knob){
    return (knob >= this.SECTION_MIN_KNOB) && (knob <= this.SECTION_MAX_BEAT_LENGTH);
  }

  setLimitRangeKnobs(lower, upper){
    this.limit_range.section_limits = {
      lower: lower,
      upper: upper
    }
  }

  setNewUpperAnchorTime(start_time, end_time){
    let hits = Math.round((end_time - start_time) / this.config.video.mean_beat_length);
    if(hits > this.SECTION_MAX_BEAT_LENGTH) hits = this.SECTION_MAX_BEAT_LENGTH;
    let hit_margin = this.SECTION_MAX_BEAT_LENGTH - hits;
    let hit_margin_top = Math.ceil(hit_margin / 2);
    this.limit_range.upper_anchor_time = end_time + hit_margin_top * this.config.video.mean_beat_length;
  }

  updateLimitRangeKnobs(current_section){
    let lower_knob_candidate = this.getLimitRangeKnob(current_section.start_time)
    let upper_knob_candidate = this.getLimitRangeKnob(current_section.end_time)
    if(this.knobCanBeShown(lower_knob_candidate) && this.knobCanBeShown(upper_knob_candidate)){
      this.setLimitRangeKnobs(lower_knob_candidate, upper_knob_candidate);
    } else {
      this.centerSectionInLimitRange(current_section);
    }
  }

  sectionShorterThanLimitRange(section){
    // the 0.8 makes sure that it is really shorter than the max because otherwise there is an infinite loop
    // there was once a situation where the raw comparison without a scaling factor (0.8) was not correct
    return (section.end_time - section.start_time) <= 0.8*(this.SECTION_MAX_BEAT_LENGTH*this.config.video.mean_beat_length)
  }

  centerSectionInLimitRange(section){
    if(this.sectionShorterThanLimitRange(section)){
      this.setNewUpperAnchorTime(section.start_time, section.end_time);
      this.updateLimitRangeKnobs(section);
    } else {
      this.limit_range.upper_anchor_time = section.start_time + (this.SECTION_MAX_BEAT_LENGTH - 4)*this.config.video.mean_beat_length;
      let lower_knob = this.getLimitRangeKnob(section.start_time)
      let upper_knob = this.getLimitRangeKnob(section.end_time)
      this.setLimitRangeKnobs(lower_knob, upper_knob);
    }
  }

  updateLimitRange(current_section){
    if(this.loop_mode == this.LOOP_MODE_FULL_VIDEO){
      this.centerSectionInLimitRange(current_section);
    }
    if(this.loop_mode == this.LOOP_MODE_SINGLE_SECTION){
      this.updateLimitRangeKnobs(current_section)
    }
  }

  moveLimitRange(direction, pauseVideo = true){
    // if(pauseVideo) this.pauseVideo();
    let offset = this.SECTION_NEW_DEFAULT_BEAT_LENGTH * this.config.video.mean_beat_length
    if(direction == this.LEFT){
      this.limit_range.upper_anchor_time -= offset;
    }
    if(direction == this.RIGHT){
      this.limit_range.upper_anchor_time += offset;
    }
    // currently we are always in LOOP_MODE_SINGLE_SECTION, then we need to adjust the visualization
    let lower_knob_candidate = this.getLimitRangeKnob(this.current_section.start_time)
    let upper_knob_candidate = this.getLimitRangeKnob(this.current_section.end_time)
    this.setLimitRangeKnobs(lower_knob_candidate, upper_knob_candidate);

    // does interfere when people want to select big parts
    // because the ionic range always needs to be in sight - otherwise, loop mode is quit
    // BUT this cannot be removed because it is dependend with how the ionic range is programmed
    // the ionic range would need to know about the whole video and has its beat-length
    if(!this.currentSectionIsVisibleOnLimitRange()) this.selectFullVideo();
  }

  currentSectionIsVisibleOnLimitRange(){
    let section_is_above = this.current_section.start_time > this.limit_range.upper_anchor_time
    let section_is_below = this.current_section.end_time < this.limit_range.upper_anchor_time - this.SECTION_MAX_BEAT_LENGTH*this.config.video.mean_beat_length
    return !(section_is_above || section_is_below);
  }

  selectSection(section, section_index, move_seeker=true){
    // if(section_index == this.active_section_index) this.centerSectionInLimitRange(section);
    this.loop_mode = this.LOOP_MODE_SINGLE_SECTION;
    this.active_section_index = section_index;
    this.current_section = this.config.video.sections[section_index];
    this.updateLimitRange(this.current_section)
    this.updateLoopBounds(this.current_section.start_time, this.current_section.end_time);
    // this.pauseVideo();
    if(move_seeker) this.seekToCurrentSection();
    // this.playVideo();
    this.enableLoop();
    this.looping = true;
    this.scrollToCurrentSection();
  }

  selectSectionClick(section, section_index){
    if(this.alt_down && this.shift_down){
      this.createSmallSectionsUntilTheEnd(section);
    } else if(this.shift_down){
      this.maybeCreateBigLoop(section_index);
    } else if(this.alt_down){
      this.createSuitableSubSections(section);
    } else {
      this.selectSection(section, section_index)
    }
  }

  scrollToCurrentSection(section_index=this.active_section_index){
    // console.log("scrollToCurrentSection(section_index)", section_index);

    if(section_index >= 0){
      let section = document.getElementById('section-' + section_index);

      if(!section){
        // if it is the last DOM Node, then we need to wait until Angular created the new DOM Node
        setTimeout(() => { this.scrollToCurrentSection()}, 100);
      } else {
        let sectionHeight = section.offsetHeight;
        let scroller = document.getElementById('section-scroller');

        if(this.sectionTooHigh(section, scroller)){
          // console.log("section was too high");
          scroller.scrollTop = scroller.scrollTop - 1.5*sectionHeight;
        } else if(this.sectionTooLow(section, scroller)){
          // console.log("section was too low");
          scroller.scrollTop = scroller.scrollTop + 1.5*sectionHeight;
        }
      }
    }
  }

  sectionTooHigh(section, scroller){
    let sectionOffsetTop = section.offsetTop;
    // console.log("sectionOffsetTop", sectionOffsetTop);
    let scrollerScrollTop = scroller.scrollTop;
    // console.log("scrollerScrollTop", scrollerScrollTop);
    let scrollerOffsetTop = scroller.offsetTop;
    // console.log("scrollerOffsetTop", scrollerOffsetTop);

    return sectionOffsetTop < scrollerScrollTop + scrollerOffsetTop;
  }

  sectionTooLow(section, scroller){
    let sectionOffsetTop = section.offsetTop;
    // console.log("sectionOffsetTop", sectionOffsetTop);
    let scrollerScrollTop = scroller.scrollTop;
    // console.log("scrollerScrollTop", scrollerScrollTop);
    let scrollerOffsetTop = scroller.offsetTop;
    // console.log("scrollerOffsetTop", scrollerOffsetTop);
    let scrollerOffsetHeight = scroller.offsetHeight;
    // console.log("scrollerOffsetHeight", scrollerOffsetHeight);
    let sectionHeight = section.offsetHeight;
    // console.log("sectionHeight", sectionHeight);
    // scroller.scrollTop = sectionOffsetTop - scrollerOffsetTop - 1.5*sectionHeight;

    return sectionOffsetTop > scrollerScrollTop + scrollerOffsetTop + scrollerOffsetHeight - sectionHeight;
  }

  maybeShowCurrentSection(){
    // MAYBE LATER: add guards in order to not trigger this function
    // eg when we just jumped within a section with alt+shift+arrow which might be overlapping
    if(this.loop_mode == this.LOOP_MODE_SINGLE_SECTION && this.currentTimeOutOfLoopRange()){
      // let margin = 0.5*this.config.video.mean_beat_length;
      let margin = 0;
      let currentTime = this.video_player.getCurrentTime();
      let section_candidate = this.config.video.sections.find((section) => {
        return section.end_time + margin > currentTime && section.start_time <= currentTime + margin;
      })
      if(section_candidate) this.selectSection({}, this.config.video.sections.indexOf(section_candidate), false)
    }
  }

  deleteSectionClick(event, section_index){
    event.stopPropagation();
    if(this.delete_sections_alert) this.showDeleteSectionAlert(section_index)
    else this.deleteSectionViaClick(section_index)
  }

  showDeleteSectionAlert(section_index){
    this.disableKeyboardShortcuts()
    let alert = this.alertCtrl.create({
      title: 'Delete section',
      message: 'Do you really want to delete this section?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            this.enableKeyboardShortcuts()
          }
        },
        {
          text: 'Delete',
          handler: () => {
            this.deleteSectionViaClick(section_index)
            this.enableKeyboardShortcuts()
          }
        }
      ]
    });
    alert.present();
  }

  deleteSectionViaClick(section_index){
    if(this.active_section_index == section_index){
      this.selectFullVideo();
    }
    this.deleteSection(section_index);
  }

  deleteSection(section_index){
    this.config.video.sections.splice(section_index, 1);
    if(this.active_section_index > section_index){
      this.active_section_index -= 1;
    }
    this.saveConfig();
  }

  deleteCurrentSectionViaKeyboard(){
    let deleted_section_index = this.active_section_index;
    this.deleteSection(deleted_section_index);
    this.setStateAfterSectionDeleteViaKeyboard(deleted_section_index);
  }

  setStateAfterSectionDeleteViaKeyboard(deleted_section_index){
    if(deleted_section_index > 0){
      this.selectPreviousSection(deleted_section_index)
    } else if(deleted_section_index <= this.config.video.sections.length - 1) {
      this.selectSection({}, deleted_section_index)
    } else {
      this.selectFullVideo();
    }
  }

  showDeleteMultipleSectionsAlert(){
    this.disableKeyboardShortcuts()
    let alert = this.alertCtrl.create({
      title: 'Delete multiple sections',
      message: 'Do you really want to delete all selected sections?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            this.enableKeyboardShortcuts()
          }
        },
        {
          text: 'Delete',
          handler: () => {
            this.deleteMultipleSections()
            this.enableKeyboardShortcuts()
          }
        }
      ]
    });
    alert.present();
  }

  deleteMultipleSections(){
    let start_index;
    let end_index;
    if(this.big_loop_section_index < this.active_section_index){
      start_index = this.big_loop_section_index;
      end_index = this.active_section_index;
    } else {
      start_index = this.active_section_index;
      end_index = this.big_loop_section_index;
    }
    let i = start_index;
    while(i <= end_index){
      // the sections are reindexed after the deletion, therefore we always delete the same index
      this.deleteSection(start_index);
      i += 1;
    }
    this.setStateAfterSectionDeleteViaKeyboard(start_index);
  }

  maybeAddOn1Indicator(){
    let new_on1_indicator = this.video_player.getCurrentTime();
    if(this.isValidNewOn1Indicator(new_on1_indicator)){
      this.config.video.on1_indicators.push(new_on1_indicator);
      this.config.video.on1_indicators.sort(function(a, b){return a-b});
      this.maybeCalibrateBeats();
    } else {
      alert("Error: This On1 already exists.")
    }
  }

  isValidNewOn1Indicator(new_indicator){
    let is_valid = true;
    this.config.video.on1_indicators.forEach((old_indicator) => {
      if(Math.abs(new_indicator - old_indicator) < 1){
        is_valid = false;
      }
    });
    return is_valid;
  }

  deleteOn1(index){
    this.config.video.on1_indicators.splice(index, 1);
    // console.log("beat_indicators", this.beat_indicators)
    this.maybeCalibrateBeats();
  }

  maybeCalibrateBeats(){
    if(this.config.video.on1_indicators.length > 1 || this.config.video.beats.length >= this.maxCount()){
      this.initialEstimation();
      this.iterativelyImproveEstimate();
      this.fillFromOn1ToOn1();
    }
  }

  getMeanBeatLength(first, second, dont_consider_offset = false){
    // return 0.50045; // saray and ivan

    let mean_beat_length_estimate = this.config.video.mean_beat_length;
    // let first_1 = 16.24;
    // let last_1 = 160.37;

    if(dont_consider_offset || this.tact_type.tacts_per_count_set == 1){
      return this.extrapolatedMeanBeatLength(mean_beat_length_estimate, second, first)
    }

    // in the following, we assume that there are no counts where we have more than 2 tacts_per_count_set

    let second_plus_half_count = second + 0.5*(mean_beat_length_estimate*this.maxCount());

    // console.log("getMeanBeatLength - old estimate:", mean_beat_length_estimate);
    let last_1_on1_new_mean_beat = this.extrapolatedMeanBeatLength(mean_beat_length_estimate, second, first)
    let last_1_on5_new_mean_beat = this.extrapolatedMeanBeatLength(mean_beat_length_estimate, second_plus_half_count, first)

    if(Math.abs(last_1_on1_new_mean_beat - mean_beat_length_estimate) < Math.abs(last_1_on5_new_mean_beat - mean_beat_length_estimate)){
      // console.log("getMeanBeatLengthWOn1 using on1", last_1_on1_new_mean_beat);
      return last_1_on1_new_mean_beat;
    } else {
      // console.log("getMeanBeatLengthWOn1 using on5", last_1_on5_new_mean_beat);
      return last_1_on5_new_mean_beat;
    }
  }

  extrapolatedMeanBeatLength(mean_beat_length_estimate, last_1, first_1){
    let diff_length = last_1 - first_1;
    // console.log("extrapolatedMeanBeatLengthWOn1 diff_length", diff_length);
    // console.log("(mean_beat_length_estimate * this.maxCount()", (mean_beat_length_estimate * this.maxCount()))
    // if the first_1 and last_1 are less than a tact length apart, we need to correct the diff_length, otherwise we divide by 0
    if(diff_length < 0.8*(mean_beat_length_estimate * this.maxCount())) diff_length += mean_beat_length_estimate * this.maxCount();
    let beats_count_estimate = Math.round(diff_length / this.maxCount() / mean_beat_length_estimate);
    let mean_beat_length_estimate_corrected = diff_length / this.maxCount() / beats_count_estimate;
    // console.log("extrapolatedMeanBeatLength", mean_beat_length_estimate_corrected);
    return mean_beat_length_estimate_corrected;
  }

  maxCount(){
    return this.tact_type.counts_per_tact * this.tact_type.tacts_per_count_set;
  }

  initialEstimation(){
    if(this.config.video.on1_indicators.length >= 2){
      if(this.config.video.beats.length < 1){
        this.config.video.mean_beat_length = (this.config.video.on1_indicators[1] - this.config.video.on1_indicators[0]) / this.maxCount();
      } else {
        this.config.video.mean_beat_length = this.getMeanBeatLength(this.config.video.on1_indicators[0], this.config.video.on1_indicators[1], true);
      }
    }
  }

  iterativelyImproveEstimate(){
    this.config.video.on1_indicators.forEach((item, index) => {
      if(index >= 2){
        // no, because Occams Razor!!
        // // only set new mean_beat_length when the new estimate is not too far away from the old one?
        // // no, because this makes everything too complicated and might be intransparent when initial estimates change a lot
        // let old_estimate = this.config.video.mean_beat_length;
        // let new_estimate = this.getMeanBeatLength(this.config.video.on1_indicators[0], this.config.video.on1_indicators[index]);
        // let diff = Math.abs(old_estimate - new_estimate);
        // if(diff < 0.4*old_estimate) {
        //   this.config.video.mean_beat_length = new_estimate;
        // } else {
          // console.log("#### IGNORED new estimate because it was too fast/slow")
        // }
        this.config.video.mean_beat_length = this.getMeanBeatLength(this.config.video.on1_indicators[0], this.config.video.on1_indicators[index]);
      }
    });
  }

  fillFromOn1ToOn1(){
    let duration = null;
    if(!this.video_player || !this.video_player.getDuration()){
      if(this.config.video.duration){
        duration = this.config.video.duration;
      } else {
        return;
      }
      // if the duration is not valid, then we should not update something
      // console.log("######## fillFromOn1ToOn1 was impossible because duration was undefined/falsy")
    }
    if(!duration) duration = this.video_player.getDuration();


    if(this.config.video.on1_indicators.length > 0){
      let beats = [];
      let start_point;

      this.config.video.on1_indicators.forEach((item, index) => {
        start_point = this.config.video.on1_indicators[index];
        if(index == 0){
          beats = this.fillBeatTillStart(beats, start_point, this.config.video.mean_beat_length);
        }
        beats = this.fillBeatTillEnd(beats, start_point, duration, this.config.video.mean_beat_length);
      });

      this.config.video.beats = JSON.parse(JSON.stringify(beats));
      this.saveConfig()
      // console.log("number of tacts are roughly: ", this.config.video.beats.length / 8);
    } else if(this.config.video.beats.length >= 1){
      // we do have a tact but not necessarily on1_indicators for example because they are not given OR were deleted
      let start_point = undefined;

      if(this.config.video.on1_indicators.length > 0){
        let first_on1_indicator = this.config.video.on1_indicators[0];
        start_point = first_on1_indicator
      } else {
        let first_on1 = this.config.video.beats.find((item) => {
          return item.count == 1
        });
        if(first_on1) start_point = first_on1.time;
      }

      if(start_point){
        let beats = [];
        // console.log("start_point", start_point);
        beats = this.fillBeatTillStart(beats, start_point, this.config.video.mean_beat_length);
        beats = this.fillBeatTillEnd(beats, start_point, duration, this.config.video.mean_beat_length);

        this.config.video.on1_indicators.forEach((item, index) => {
          start_point = this.config.video.on1_indicators[index];
          beats = this.fillBeatTillEnd(beats, start_point, duration, this.config.video.mean_beat_length);
        });

        this.config.video.beats = JSON.parse(JSON.stringify(beats));
        this.saveConfig()
        // console.log("number of tacts are roughly: ", this.config.video.beats.length / 8);
      }
    }
  }

  fillBeatTillEnd(beats, start_point, duration, mean_beat_length){
    // delete all existing beats which are beyond the start_point
    beats = beats.filter(beat => beat.time < start_point)
    beats = this.maybeDeleteResidualOn5Beats(beats)

    let beat_count = Math.floor((duration - start_point) / mean_beat_length);
    // let beat_count = Math.floor((173.446 - start_point) / mean_beat_length)

    let index = 0;
    while(index < beat_count){
      beats.push({
        time: start_point + index*mean_beat_length,
        count: index%this.maxCount() +1
      });
      if(this.tact_show_syncopations){
        beats.push({
          time: start_point + index*mean_beat_length + mean_beat_length/2,
          count: (index%this.maxCount() +1) + "&"
        });
      }
      index += 1;
    }
    // console.log(beats)
    return beats;
  }

  maybeDeleteResidualOn5Beats(beats){
    if(this.tact_type.tacts_per_count_set <= 1){
      // the residual on5 cannot happen
      return beats;
    } else {
      // if the last beat is a 5 or 5& then we also remove it
      // this is a residual on5 and happens when the on1.time is a little bit later then the previous on5.time
      if(beats.length >= 1) beats = this.maybeDeleteResidualOn5Beat(beats, beats.length - 1);
      if(beats.length >= 2) beats = this.maybeDeleteResidualOn5Beat(beats, beats.length - 2);
      return beats;
    }
  }

  maybeDeleteResidualOn5Beat(beats, beat_index){
    // counts_per_tact: 3,
    // tacts_per_count_set: 2,

    // we assume that the max tacts_per_count_set is 2 and that this is the state that we are in
    // because tacts_per_count_set == 1 has been filtered out earlier
    let residual_count = this.tact_type.counts_per_tact + 1;
    if(beats[beat_index].count.toString().includes(residual_count.toString())){
      beats.splice(beat_index, 1);
    }
    return beats;
  }

  fillBeatTillStart(beats, start_point, mean_beat_length){
    let beat_count = Math.floor(start_point / mean_beat_length);

    let index = 0;
    while(index < beat_count){
      if(this.tact_show_syncopations){
        beats.unshift({
          time: start_point - (index+1)*mean_beat_length + mean_beat_length/2,
          count: (this.maxCount() -index%this.maxCount()) + "&"
        });
      }
      beats.unshift({
        time: start_point - (index+1)*mean_beat_length,
        count: this.maxCount() -index%this.maxCount()
      });
      index += 1;
    }
    // console.log(beats)
    return beats;
  }

  selectTactType() {
    let alert = this.alertCtrl.create();
    alert.setTitle('Select Tact Type');
    alert.setMessage('Attention: If you change the tact, you will delete the old tact and On1 inputs.');

    let tact_type;
    for (let tact_type_key in this.TACT_TYPE_COLLECTION) {
      tact_type = this.TACT_TYPE_COLLECTION[tact_type_key];
      alert.addInput({
        type: 'radio',
        value: tact_type.name,
        label: tact_type.label,
        checked: this.tact_type.name == tact_type.name
      });
    }

    alert.addButton('Cancel');
    alert.addButton({
      text: 'OK',
      handler: data => {
        this.tact_type = this.TACT_TYPE_COLLECTION[data];
        this.resetTact();
      }
    });
    alert.present();
  }

  onChangedSyncopationsSettings(){
    // console.log("onChangedSyncopationsSettings", this.tact_show_syncopations);
    this.maybeCalibrateBeats();
  }

  resetTact(save=true){
    this.config.video.beats = [];

    this.config.video.on1_indicators = [];
    if(save) this.saveConfig();
  }

  @HostListener('window:keydown', ['$event'])
  keyDownEvent(event: KeyboardEvent) {
    // console.log(event);
    if(!this.keyboard_shortcuts_enabled){
      // console.log("keyboard_shortcuts disabled");
      return;
    }
    event.preventDefault(); // eg dont scroll with arrow or space; dont navigate history with CMD + arrow

    // debugger;
    if(event.keyCode === KEY_CODE.SHIFT){
      this.shift_down = true;
    }

    if(event.key == KEY.CONTROL){
      this.ctrl_down = true;
    }

    if(event.key == KEY.ALT){
      this.alt_down = true;
    }

    if(event.keyCode === KEY_CODE.SPACE){
      this.toggleVideo(false);
    }

    if(event.keyCode === KEY_CODE.ARROW_LEFT) {
      if(this.shift_down && this.alt_down){
        let margin = this.config.video.mean_beat_length;
        if(this.getSeekerTime() <= this.current_section.end_time + margin){
          this.goToCurrentSectionStart();
        } else {
          this.pauseAtCurrentSectionEnd();
        }

      } else if(this.shift_down){
        this.updateLoopLimitFromSeeker(this.LEFT);
        // this.updateLowerLoopLimitFromSeeker();
      } else if(this.alt_down) {
        this.moveLimitRange(this.LEFT);
      } else {
        this.maybeMove1Beat('back')
      }
    }

    if(event.keyCode === KEY_CODE.ARROW_RIGHT) {
      if(this.shift_down && this.alt_down){
        let margin = this.config.video.mean_beat_length;
        if(this.getSeekerTime() >= this.current_section.start_time - margin){
          this.pauseAtCurrentSectionEnd();
        } else {
          this.goToCurrentSectionStart();
        }

      } else if(this.shift_down){
        this.updateLoopLimitFromSeeker(this.RIGHT);
        // this.updateUpperLoopLimitFromSeeker();
      } else if(this.alt_down) {
        this.moveLimitRange(this.RIGHT);
      } else {
        this.maybeMove1Beat('ahead')
      }
    }

    if(event.keyCode === KEY_CODE.ARROW_UP) {
      if(this.shift_down){
        // maybe select previous one for big loop
        this.createNewSection(this.BEFORE_CURRENT_SECTION);
      } else if(this.alt_down) {
        this.createNewSection(this.BEFORE_CURRENT_SECTION);
      } else {
        if(this.current_section.start_time <= this.config.video.mean_beat_length){
          this.selectFullVideo();
        } else {
          // otherwise, we should ask if we should add another section
          this.selectPreviousSection();
          // this.goToPreviousSectionOrCreate();
        }
      }
    }

    if(event.keyCode === KEY_CODE.ARROW_DOWN) {
      if(this.shift_down){
        // maybe select next one for big loop
        this.createNewSection(this.AFTER_CURRENT_SECTION);
      } else if(this.alt_down) {
        this.createNewSection(this.AFTER_CURRENT_SECTION);
      } else {
        this.selectNextSection();
        // otherwise, we should ask if we should add another section
        // this.goToNextSectionOrCreate();
      }
    }

    if(event.key == KEY.DELETE || event.key == KEY.BACKSPACE){
      if(this.loop_mode == this.LOOP_MODE_SINGLE_SECTION){
        this.deleteCurrentSectionViaKeyboard();
      } else if(this.loop_mode == this.LOOP_MODE_MULTIPLE_SECTIONS){
        this.showDeleteMultipleSectionsAlert();
      }
    }

    if(event.key == KEY.ENTER){
      // this.createNewSection(this.BEFORE_CURRENT_TIME, false, 4)
      if(this.loop_mode == this.LOOP_MODE_SINGLE_SECTION){
        this.createNewIntelligentSectionFromLoopMode()
        // if(this.shift_down) this.createNewSection(this.BEFORE_CURRENT_TIME)
        // else this.createNewSection(this.AFTER_CURRENT_TIME)

      } else if(this.loop_mode == this.LOOP_MODE_FULL_VIDEO) {
        let select_section = false;
        if(this.shift_down) select_section = true;
        let beat_count = this.SECTION_BEAT_LENGTH_AFTER_ENTER;
        this.createNewSection(this.BEFORE_CURRENT_TIME, select_section, beat_count)
      }
    }

    if(event.key == KEY.ESCAPE){
      if(this.loop_mode == this.LOOP_MODE_SINGLE_SECTION){
        if(this.loop_enabled) this.disableLoop()
        else if(!this.loop_enabled) this.selectFullVideo()
      } else if(this.loop_mode == this.LOOP_MODE_MULTIPLE_SECTIONS){
        this.selectSection({}, this.active_section_index);
      }
    }

    if(event.code == KEY_CODE.KEY_S){
      this.show_settings = !this.show_settings;
    }

    if(event.code == KEY_CODE.KEY_M){
      this.mirror_video = !this.mirror_video;
    }

    if(event.code == KEY_CODE.KEY_T){
      this.play_count_sounds = !this.play_count_sounds;
    }
  }

  @HostListener('window:keyup', ['$event'])
  keyUpEvent(event: KeyboardEvent) {
    // console.log(event)
    if(!this.keyboard_shortcuts_enabled){
      // console.log("keyboard_shortcuts disabled");
      return;
    }
    event.preventDefault(); // eg dont scroll with arrow or space; dont navigate history with CMD + arrow

    if(event.keyCode === KEY_CODE.SHIFT){
      this.shift_down = false;
    }

    if(event.key == KEY.CONTROL){
      this.ctrl_down = false;
    }

    if(event.key == KEY.ALT){
      this.alt_down = false;
    }
  }

  maybeMove1Beat(direction){
    let old_time = this.video_player.getCurrentTime()
    let new_time = old_time;
    let offset;
    if(this.tact_show_syncopations){
      offset = this.config.video.mean_beat_length / 2;
    } else {
      offset = this.config.video.mean_beat_length;
    }
    if(direction == 'back') new_time -= offset;
    if(direction == 'ahead') new_time += offset;
    if(new_time >= 0.0 && new_time < this.video_player.getDuration()){
      this.video_player.setCurrentTime(new_time);
      this.record_player.setCurrentTime(this.record_player.getCurrentTime() + (new_time - old_time));
      if(this.loop_mode != this.LOOP_MODE_FULL_VIDEO) this.maybeMoveLimitRange(new_time)
      // this.maybeMoveLimitRange(new_time) // TODO this was the old version
    }
    this.pauseAllVideos()
    this.maybeEnableOrDisableLoop();
    // this.maybeShowCurrentSection()
  }

  // play/pause automatically done by videojs when clicking on player
  // therefore, we need to invert the state because we dont observe the paused before but after the click
  toggleVideo(clicked_on_video_player=true){
    if(this.isRecording) {
      this.stopRecording();
      return
    }

    // console.log("toggleVideo", this.video_player.isPaused());
    if(this.video_player.isPaused()){
      if(!clicked_on_video_player) this.playVideo() // automatically done by videojs
      // this.playVideo()
      if(this.show_record_player) {
        if(clicked_on_video_player) this.forcePauseRecording();
        else this.forcePlayRecording();
      }
    } else {
      if(!clicked_on_video_player) this.pauseVideo(); // automatically done by videojs
      // this.pauseVideo()
      if(this.show_record_player && !this.userStreamIsShown) {
        if(clicked_on_video_player) this.forcePlayRecording();
        else this.forcePauseRecording();
      }
    }
    this.maybeEnableOrDisableLoop();
  }

  // pauseVideoClick(event){
  //   event.stopPropagation();
  //   this.pauseVideo()
  // }

  pauseVideo(){
    this.video_player.pause();
  }

  // playVideoClick(event){
  //   event.stopPropagation();
  //   this.playVideo()
  // }

  playVideo(){
    this.video_player.play();
  }

  toggleSpeed(){
    this.speed += 0.25;
    if(this.speed > 1){
      this.speed = 0.5
    }
    this.video_player.setPlaybackRate(this.speed);
    this.record_player.setPlaybackRate(this.speed);
  }

  increaseSpeed(){
    this.speed += 0.25;
    // if(this.speed < 1){
    //   this.speed += 0.25;
    // }
    // else if(this.speed == 1) this.speed = 1.5;
    // else if(this.speed == 1.5) this.speed = 2;
    // else if(this.speed == 2) this.speed = 3;
    this.updateSpeed();
  }

  decreaseSpeed(){
    if(this.speed == 0.25){
      // alert("This is the minimum speed.")
      return;
    }

    this.speed -= 0.25;
    this.updateSpeed();
    // if(this.speed <= 1){
    //   this.speed -= 0.25;
    // }
    // else if(this.speed == 1.5) this.speed = 1;
    // else if(this.speed == 2) this.speed = 1.5;
    // else if(this.speed == 3) this.speed = 2;
  }

  updateSpeed(){
    if(isMobileBrowser()){
      // this does not work on iOS Google Chrome
      this.setSpeedForMobile();
    } else {
      // this.setSpeedForMobile();
      this.setSpeedForLaptop();
    }
  }

  setSpeedForLaptop(){
    this.video_player.setPlaybackRate(this.speed);
    this.record_player.setPlaybackRate(this.speed);
  }

  setSpeedForMobile(){
    // https://stackoverflow.com/questions/41563995/how-to-change-speed-on-embedded-youtube-video
    // it did work on web, but on web we also have the API method for setPlackbackRate
    // it did not work on mobile iOS Chrome
    let data = {event: 'command', func: 'setPlaybackRate', args: [this.speed, true]};
    let message = JSON.stringify(data);
    let iframe = document.getElementsByTagName('iframe')[0];
    console.log("iframe", iframe);
    iframe.contentWindow.postMessage(message, '*');
  }

  setSpeed(new_speed){
    this.speed = new_speed;
    this.video_player.setPlaybackRate(this.speed);
    this.record_player.setPlaybackRate(this.speed);
  }

  seekToLoopStart(){
    this.video_player.setCurrentTime(this.loop_start_time);
  }

  maybeEnforceSingleSectionLoop(currentTime){
    if(this.loop_mode == this.LOOP_MODE_SINGLE_SECTION && this.loop_enabled && currentTime > this.loop_end_time){
      this.seekToLoopStart();
    }
  }

  maybeEnforceMultipleSectionsLoop(currentTime){
    if(this.loop_mode == this.LOOP_MODE_MULTIPLE_SECTIONS && currentTime > this.loop_end_time){
      this.seekToLoopStart();
    }
  }

  updateSeeker(currentTime){
    this.zone.run(() => {
      this.setSeekerTime(currentTime);
    });
    // console.log("updated Seeker with Video Time: ", currentTime);
  }

  maybeMoveLimitRange(currentTime=this.video_player.getCurrentTime()){
    // let margin = 1*this.config.video.mean_beat_length;
    let margin = 0;
    if(currentTime > this.limit_range.upper_anchor_time - margin){
      this.moveLimitRange(this.RIGHT, false)
    } else if(currentTime < this.limit_range.upper_anchor_time - this.SECTION_MAX_BEAT_LENGTH*this.config.video.mean_beat_length + margin){
      this.moveLimitRange(this.LEFT, false)
    }
  }

  maybeUpdateBeatCountDisplay(currentTime = this.video_player.getCurrentTime()){
    try {
      if(this.config.video.beats.length > 0){
        this.updateBeatCountDisplay(currentTime);
      }
    } catch(error) {
      // console.log("error in maybeUpdateBeatCountDisplay");
    }
  }

  updateBeatCountDisplay(currentTime = this.video_player.getCurrentTime()){
    // console.log("start:", new Date().getTime());
    let current_beat_candidate = this.config.video.beats.find((item) => {
      return item.time > (currentTime - this.config.video.mean_beat_length + this.config.video.beat_offset_ms/1000)
    });
    if(current_beat_candidate){
      this.current_beat = current_beat_candidate;
      this.zone.run(() =>{
        this.current_beat = current_beat_candidate;
      })
      this.maybePlayBeatSound()
    }
    // console.log("end:", new Date().getTime());
  }

  maybePlayBeatSound(){
    if(this.play_count_sounds){
      if(this.current_beat.count != this.last_beat.count){
        this.playSound(this.current_beat.count)
        this.last_beat = this.current_beat;
      }
    }
  }

  playSound(count){
    if(count == 1) this.BEAT_SOUND_1.play()
    else if(count == 2) this.BEAT_SOUND_2.play()
    else if(count == 3) this.BEAT_SOUND_3.play()
    else if(count == 4) this.BEAT_SOUND_4.play()
    else if(count == 5) this.BEAT_SOUND_5.play()
    else if(count == 6) this.BEAT_SOUND_6.play()
    else if(count == 7) this.BEAT_SOUND_7.play()
    else if(count == 8) this.BEAT_SOUND_8.play()
  }

  startVideoMonitoring(){
    if(!this.video_monitoring_interval){
      // console.log("startVideoMonitoring");
      this.video_monitoring_interval = setInterval(() => {
        // console.log("interval loop");
        let currentTime = this.video_player.getCurrentTime();
        if(this.looping){
          this.maybeEnforceSingleSectionLoop(currentTime)
          this.maybeEnforceMultipleSectionsLoop(currentTime)
          this.updateSeeker(currentTime)
          if(this.loop_mode == this.LOOP_MODE_SINGLE_SECTION) this.maybeMoveLimitRange(currentTime)
        }
        this.maybeUpdateBeatCountDisplay(currentTime);
      }, Math.round(VideoAdapter.YT_SEEK_INTERVAL_MS / 6)); // raceConditions: needs to be faster than videoAdapter monitoring for youtubePlayer
    }
  }

  stopVideoMonitoring(){
    // console.log("stopVideoMonitoring");
    if(this.video_monitoring_interval) {
      clearInterval(this.video_monitoring_interval);
      this.video_monitoring_interval = null;
    }
  }

  toggleLoop(){
    this.looping = !this.looping;
  }

  getCurrentSectionDiff(){
    let section = this.config.video.sections[this.active_section_index];
    return section.end_time - section.start_time
  }

  selectPreviousSection(section_index?){
    if(typeof section_index == "undefined"){
      section_index = this.active_section_index;
    }
    if(section_index > 0){
      this.selectSection({}, section_index - 1);
    } else {
      this.selectFullVideo();
    }
  }

  selectNextSection(section_index?){
    if(typeof section_index == "undefined"){
      section_index = this.active_section_index;
    }
    if(section_index < this.config.video.sections.length - 1){
      this.selectSection({}, section_index + 1);
    }
  }

  isFirstSection(){
    return this.active_section_index == 0;
  }

  isLastSection(){
    return this.active_section_index == (this.config.video.sections.length - 1);
  }

  goToPreviousSectionOrCreate() {
    if(this.active_section_index >= 1){
      this.selectPreviousSection();
    } else {
      // console.log("this is the first section", this.active_section_index)
      this.createNewSection(this.BEFORE_CURRENT_SECTION);
    }
  }

  goToNextSectionOrCreate() {
    if(this.config.video.sections.length > this.active_section_index + 1){
      this.selectNextSection();
    } else {
      // console.log("no more sections", this.active_section_index);
      this.createNewSection(this.AFTER_CURRENT_SECTION);
    }
  }

  addSection(section, select_section, move_seeker=true){
    this.config.video.sections.push(section);
    let section_index = this.config.video.sections.indexOf(section);
    if(select_section) this.selectSection({}, section_index, move_seeker);
  }

  safelySortSections(){
    this.sortSections();
    if(this.loop_mode != this.LOOP_MODE_FULL_VIDEO){
      this.active_section_index = this.config.video.sections.indexOf(this.current_section);
    }
  }

  sortSections(){
    // first, we sort by start_time
    // if start_time is similar, the longer section is on top because it visually wraps the smaller one
    this.config.video.sections.sort((a, b) => {
      if(Math.abs(a.start_time - b.start_time) > this.config.video.mean_beat_length*0.5){
        return a.start_time - b.start_time
      } else {
        return b.end_time - a.end_time // attention: reversed order of a and b
      }
    });
  }

  createSectionBefore(select_section=true){
    if(this.looping){
      this.goToPreviousSectionOrCreate();
    } else {
      this.createNewSection(this.BEFORE_CURRENT_TIME, select_section)
    }
  }

  createSectionAfterwards(){
    if(this.looping){
      this.goToNextSectionOrCreate();
    } else {
      this.createNewSection(this.AFTER_CURRENT_TIME)
    }
  }

  createNewIntelligentSectionFromLoopMode(){
    let margin = this.SECTION_NEW_DEFAULT_BEAT_LENGTH*this.config.video.mean_beat_length;
    let direction = "";
    if(this.getSeekerTime() <= (this.current_section.start_time - margin)){
      direction = this.BEFORE_CURRENT_TIME
    } else if(this.getSeekerTime() <= this.current_section.start_time){
      direction = this.BEFORE_CURRENT_SECTION
    } else if(this.getSeekerTime() >= this.current_section.end_time + margin){
      direction = this.AFTER_CURRENT_TIME
    } else if(this.getSeekerTime() >= this.current_section.end_time){
      direction = this.AFTER_CURRENT_SECTION
    }
    this.createNewSection(direction, true, this.SECTION_NEW_DEFAULT_BEAT_LENGTH, false);
  }

  createNewSection(direction, select_section=true, beat_count=this.SECTION_NEW_DEFAULT_BEAT_LENGTH, move_seeker=true){
    // console.log("createNewSection", direction)
    let [new_start_time, new_end_time] = this.getStartAndEndTime(direction, beat_count)

    let section = {
      name: this.SECTION_DEFAULT_NAME,
      start_time: new_start_time,
      end_time: new_end_time,
    };
    this.addSection(section, select_section, move_seeker);
    this.saveConfig();
  }

  getStartAndEndTime(direction, beat_count){
    let new_end_time;
    let new_start_time;
    if(direction == this.BEFORE_CURRENT_TIME){
      new_end_time = this.video_player.getCurrentTime();
      new_start_time = Math.max(0, new_end_time - beat_count*this.config.video.mean_beat_length);
    }
    if(direction == this.AFTER_CURRENT_TIME){
      new_start_time = this.video_player.getCurrentTime();
      new_end_time = Math.min(this.video_player.getDuration(), new_start_time + beat_count*this.config.video.mean_beat_length);
    }
    if(direction == this.BEFORE_CURRENT_SECTION){
      new_end_time = this.current_section.start_time;
      new_start_time= Math.max(0, new_end_time - beat_count*this.config.video.mean_beat_length);
    }
    if(direction == this.AFTER_CURRENT_SECTION){
      new_start_time = this.current_section.end_time;
      new_end_time = Math.min(this.video_player.getDuration(), new_start_time + beat_count*this.config.video.mean_beat_length);
    }
    if(new_end_time <= 0){
      new_end_time = beat_count*this.config.video.mean_beat_length;
    }
    return [new_start_time, new_end_time]
  }

  getLimitKnobValueFromSeeker(){
    let limit_knob_value = this.SECTION_MAX_BEAT_LENGTH - Math.round((this.limit_range.upper_anchor_time - this.getSeekerTime())/this.config.video.mean_beat_length);
    if(limit_knob_value > this.SECTION_MAX_BEAT_LENGTH) limit_knob_value = this.SECTION_MAX_BEAT_LENGTH
    if(limit_knob_value < this.SECTION_MIN_KNOB) limit_knob_value = this.SECTION_MIN_KNOB
    return limit_knob_value;
  }

  updateLoopLimitFromSeeker(direction){
    // this is more intuitive because the user focuses on a knob and the position that he wants to move it
    // console.log("updateLoopLimitFromSeeker", direction);
    if(this.getSeekerTime() <= this.current_section.start_time){
      this.updateLowerLoopLimitFromSeeker();
    }
    else if(this.getSeekerTime() >= this.current_section.end_time){
      this.updateUpperLoopLimitFromSeeker();
    }
    else if(direction == this.LEFT){
      this.updateUpperLoopLimitFromSeeker();
    }
    else if(direction == this.RIGHT){
      this.updateLowerLoopLimitFromSeeker();
    }
    this.enableLoop();
  }

  updateLowerLoopLimitFromSeeker(){
    // console.log("updateLowerLoopLimitFromSeeker");
    let new_lower_knob = this.getLimitKnobValueFromSeeker()
    let new_upper_knob = this.limit_range.section_limits.upper;
    let new_section_limits = {
      lower: new_lower_knob,
      upper: new_upper_knob
    }
    this.setNewSectionLimits(new_section_limits, true)
  }

  updateUpperLoopLimitFromSeeker(){
    // console.log("updateUpperLoopLimitFromSeeker");
    let new_lower_knob = this.limit_range.section_limits.lower;
    let new_upper_knob = this.getLimitKnobValueFromSeeker();
    let new_section_limits = {
      lower: new_lower_knob,
      upper: new_upper_knob
    }
    this.setNewSectionLimits(new_section_limits, false)
  }

  setNewSectionLimits(new_section_limits, lower_knob_changed){
    // console.log("setNewSectionLimits", [new_section_limits, lower_knob_changed]);
    if(lower_knob_changed){
      // console.log("lowerKnobChanged");
      this.current_section.start_time = this.limit_range.upper_anchor_time - (this.SECTION_MAX_BEAT_LENGTH-new_section_limits.lower)*this.config.video.mean_beat_length;
      this.updateLoopBoundsForCurrentSection();
      this.video_player.setCurrentTime(this.current_section.start_time);
    } else {
      // console.log("upperKnobChanged");
      this.current_section.end_time = this.limit_range.upper_anchor_time - (this.SECTION_MAX_BEAT_LENGTH-new_section_limits.upper)*this.config.video.mean_beat_length;
      this.updateLoopBoundsForCurrentSection();
      this.video_player.setCurrentTime(this.current_section.end_time);
    }
    this.limit_range.section_limits = new_section_limits;
    // console.log("new section: ", this.current_section);
    this.saveConfig();
  }

  sectionLimitsChanged(new_sections_limits){
    if(this.upperKnobChanged(new_sections_limits)){
      this.pauseVideo()
    }
    // console.log("sectionLimitsChanged", new_sections_limits);
    this.setNewSectionLimits(new_sections_limits, this.lowerKnobChanged(new_sections_limits))
    this.enableLoop();
  }

  lowerKnobChanged(new_sections_limits){
    return this.limit_range.section_limits.lower != new_sections_limits.lower;
  }

  upperKnobChanged(new_sections_limits){
    return !this.lowerKnobChanged(new_sections_limits);
  }

  sectionSeekerModelChange(new_seeker_value){
    // console.log("sectionSeekerModelChange", new_seeker_value);
    this.pauseVideo();
    this.seeker = new_seeker_value;
    this.video_player.setCurrentTime(this.getSeekerTime());
    // this.maybeShowCurrentSection();
    this.maybeEnableOrDisableLoop();
  }

  seekToCurrentSection(){
    this.video_player.setCurrentTime(this.current_section.start_time);
  }

  pauseAtCurrentSectionEnd(){
    // we need to pause because if we are playing the loop will jump to the start
    this.pauseVideo();
    this.video_player.setCurrentTime(this.current_section.end_time);
  }

  goToCurrentSectionStart(){
    // sometimes you just want to jump to the start again
    this.video_player.setCurrentTime(this.current_section.start_time);
  }

  getBigLoopTimes(){
    let start_time;
    let end_time;
    if(this.active_section_index < this.big_loop_section_index){
      start_time = this.current_section.start_time
      end_time = this.config.video.sections[this.big_loop_section_index].end_time
    } else {
      start_time = this.config.video.sections[this.big_loop_section_index].start_time
      end_time = this.current_section.end_time
    }
    return [start_time, end_time]
  }

  createBigLoopClick(event, section_index){
    event.stopPropagation();
    this.maybeCreateBigLoop(section_index);
  }

  maybeCreateBigLoop(section_index){
    if(section_index != this.active_section_index){
      this.createBigLoop(section_index);
    } else {
      alert("Please select another section if you want to loop multiple sections.")
    }
  }

  createBigLoop(section_index){
    this.big_loop_section_index = section_index;
    let [start_time, end_time] = this.getBigLoopTimes();
    this.big_loop_section = {
      start_time: start_time,
      end_time: end_time,
    }
    this.updateLoopBounds(start_time, end_time);
    this.loop_mode = this.LOOP_MODE_MULTIPLE_SECTIONS;
    this.pauseVideo();
    this.video_player.setCurrentTime(start_time);
  }

  isPartOfBigLoop(section_index){
    if(this.loop_mode != this.LOOP_MODE_MULTIPLE_SECTIONS){
      return false;
    }
    if(this.active_section_index < this.big_loop_section_index){
      return section_index >= this.active_section_index && section_index <= this.big_loop_section_index
    } else {
      return section_index >= this.big_loop_section_index && section_index <= this.active_section_index
    }
  }

  updateLoopBounds(start_time, end_time){
    this.loop_start_time = start_time;
    this.loop_end_time = end_time;
  }

  updateLoopBoundsForCurrentSection(){
    this.loop_start_time = this.current_section.start_time;
    this.loop_end_time = this.current_section.end_time;
  }

  getSeekerTime(){
    return this.seeker / this.SEEKER_ACCURACY;
  }

  setSeekerTime(time){
    this.seeker = time * this.SEEKER_ACCURACY;
  }

  formatTime(time){
    let minutes = Math.floor(time / 60);
    let seconds = Math.floor(time % 60);
    // let seconds_value = this.decimalPipe.transform(seconds, '1.2-2')
    let seconds_value = this.decimalPipe.transform(seconds, '2.0-0')
    // console.log(`${minutes}:${seconds_value}`)
    return `${minutes}:${seconds_value}`
  }

  currentTimeOutOfLoopRange(){
    let below_loop_range = this.video_player.getCurrentTime() < (this.current_section.start_time - this.TIME_ACCURACY_EPSILON)
    let above_loop_range = this.video_player.getCurrentTime() > (this.current_section.end_time + this.TIME_ACCURACY_EPSILON)
    return below_loop_range || above_loop_range;
  }

  currentTimeLaterThanLoopLimit(){
    return this.video_player.getCurrentTime() > this.current_section.end_time
  }

  maybeEnableOrDisableLoop(){
    // alternative is currentTimeOutOfLoopRange() however, then we will also quit the loop if we check some beatss before the loop
    // alternative is currentTimeLaterThanLoopLimit() - this will only disable the loop when clicking out of it on the "top" or to "the right"
    if(this.looping && this.currentTimeOutOfLoopRange()){
      this.loop_enabled = false;
    } else {
      this.enableLoop();
    }
  }

  enableLoop(){
    this.loop_enabled = true;
  }

  disableLoop(){
    this.loop_enabled = false;
  }

  toggleBeatHeaderPosition(){
    this.show_beat_count_header_left = !this.show_beat_count_header_left;
  }

  renameSectionClick(event, section_index){
    event.stopPropagation();
    this.renameSection(section_index);
  }

  renameSection(section_index) {
    let prompt = this.alertCtrl.create({
      title: 'Rename Section',
      // message: "Enter a new section name",
      inputs: [
        {
          name: 'Name',
          value: this.config.video.sections[section_index].name,
          // placeholder: this.config.video.sections[section_index].name
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: data => {
            // console.log('Cancel clicked');
            this.disableKeyboardInput();
          }
        },
        {
          text: 'Save',
          handler: data => {
            // console.log('Saved clicked', data);
            this.config.video.sections[section_index].name = data.Name;
            this.saveConfig();
            this.disableKeyboardInput();
          }
        }
      ]
    });
    this.enableKeyboardInput();
    prompt.present();
  }

  enableKeyboardShortcuts(){
    this.keyboard_shortcuts_enabled = true;
  }

  disableKeyboardShortcuts(){
    this.keyboard_shortcuts_enabled = false;
  }

  enableKeyboardInput(){
    this.disableKeyboardShortcuts();
    this.stopFocusToBodyInterval();
  }

  disableKeyboardInput(){
    this.enableKeyboardShortcuts();
    this.maybeStartFocusToBodyInterval();
  }

  noLinesAttribute(section_index){
    if(this.nextSectionIsFarAway(section_index)){
      return ''
    } else {
      return null
    }
  }

  nextSectionIsFarAway(section_index){
    if(section_index >= this.config.video.sections.length - 1) return true;
    if(section_index < 0) return false;

    let section = this.config.video.sections[section_index];
    let next_section = this.config.video.sections[section_index + 1];
    // if(next_section.start_time > (section.end_time + this.SECTION_MAX_BEAT_LENGTH*this.config.video.mean_beat_length)){
    if(next_section.start_time > (section.end_time + 3*this.config.video.mean_beat_length)){
      return true;
    } else {
      return false;
    }
  }

  previousSectionIsFarAway(section_index){
    return this.nextSectionIsFarAway(section_index - 1);
  }

  adjustBeatOffset(new_beat_offset_ms){
    this.config.video.beat_offset_ms = new_beat_offset_ms;
    this.maybeUpdateBeatCountDisplay();
  }

  showKeyboardShortcuts(event) {
    this.navCtrl.push("KeyboardShortcutsPage");
    // let popover = this.popoverController.create("KeyboardShortcutsPage");
    // popover.present({
    //   ev: event
    // });
  }

  showVoiceCommands(event) {
    this.navCtrl.push("VoiceCommandsPage");
    // let popover = this.popoverController.create("KeyboardShortcutsPage");
    // popover.present({
    //   ev: event
    // });
  }

  async initUserMedia() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia(this.constraints);
      this.showUserStream(stream);
    } catch (e) {
      // console.log("video recording error", e)
    }
  }

  showUserStream(stream=this.userStream) {
    const videoTracks = stream.getVideoTracks();
    // console.log('Got stream with constraints:', this.constraints);
    // console.log(`Using video device: ${videoTracks[0].label}`);

    // // const superBuffer = new Blob(this.recordedBlobs, {type: 'video/webm; codecs="vp8"'});
    // this.record_player.setStream(null);
    // this.record_player.src({ type: 'video/webm', src: stream})

    this.record_player.setStream(stream);
    this.record_player.player.one("canplay", () => {
      // console.log("recordplayer - canplay")
      this.forcePlayRecording();
    })
    // this.record_player.srcObject = stream;
    this.userStreamIsShown = true;
  }

  async initRecording(){
    try {
      this.userStream = await navigator.mediaDevices.getUserMedia(this.constraints);
      this.showUserStream();
      this.mediaSource.addEventListener('sourceopen', this.handleSourceOpen, false);
      this.recording_is_initialized = true;
      this.finishShowRecording();
    } catch (e) {
      console.error('navigator.getUserMedia error:', e);
    }
  }

  handleSourceOpen(event) {
    // console.log('MediaSource opened');
    this.sourceBuffer = this.mediaSource.addSourceBuffer('video/webm; codecs="vp8"');
    // console.log('Source buffer: ', this.sourceBuffer);
  }

  handleDataAvailable(event) {
    if (event.data && event.data.size > 0) {
      this.recordedBlobs.push(event.data);
    }
  }

  startRecordingClick(event){
    event.stopPropagation();
    this.startRecording();
  }

  startRecording() {
    this.recordedBlobs = [];
    let options = {mimeType: 'video/webm;codecs=vp9'};
    if (!MediaRecorder.isTypeSupported(options.mimeType)) {
      console.error(`${options.mimeType} is not Supported`);
      options = {mimeType: 'video/webm;codecs=vp8'};
      if (!MediaRecorder.isTypeSupported(options.mimeType)) {
        console.error(`${options.mimeType} is not Supported`);
        options = {mimeType: 'video/webm'};
        if (!MediaRecorder.isTypeSupported(options.mimeType)) {
          console.error(`${options.mimeType} is not Supported`);
          options = {mimeType: ''};
        }
      }
    }

    try {
      this.mediaRecorder = new MediaRecorder(this.userStream, options);
    } catch (e) {
      console.error('Exception while creating MediaRecorder:', e);
      return;
    }

    // console.log('Created MediaRecorder', this.mediaRecorder, 'with options', options);

    this.mediaRecorder.onstop = (event) => {
      // console.log('Recorder stopped: ', event);
    };
    this.mediaRecorder.ondataavailable = (event) => {
      if (event.data && event.data.size > 0) {
        this.recordedBlobs.push(event.data);
      }
    };
    this.mediaRecorder.start(10); // collect 10ms of data
    // console.log('MediaRecorder started', this.mediaRecorder);

    this.showUserStream();
    this.isRecording = true;
    this.recordStartTime = this.video_player.getCurrentTime();
    this.playVideo();
  }

  stopRecordingClick(event){
    event.stopPropagation();
    this.stopRecording();
  }

  stopRecording() {
    // console.log("stopRecording");
    this.mediaRecorder.stop();
    // console.log('Recorded Blobs: ', this.recordedBlobs);
    this.isRecording = false;
    this.pauseAllVideos();

    if(this.show_record_player) this.prepareReplay(); // it might be cancelled and hidden already
  }

  prepareReplay(){
    const superBuffer = new Blob(this.recordedBlobs, {type: 'video/webm'});
    const recording = window.URL.createObjectURL(superBuffer);
    this.record_player.setStream(null);
    this.userStreamIsShown = false;

    this.record_player.src({ type: 'video/webm', src: recording})
    this.record_player_is_paused = true; // because there is no auto-play
    this.video_player.setCurrentTime(this.recordStartTime);

    this.record_player.player.one("canplay", () => {
      this.playAllVideos();
    })

    // when the user clicks the ProgressControl while the video is playing, the videoJS player pauses
    this.record_player.player.controlBar.progressControl.el_.addEventListener("click", () => {
      this.record_player_is_paused = true;
      this.pauseVideo();
    }, true);

    this.record_player.onended(() => {
      if(this.record_player_is_paused) return;
      this.forcePlayRecording();
      this.video_player.setCurrentTime(this.recordStartTime);
      this.playVideo()
    });

    this.record_player.onseeked(() => {
      this.maybeSynchronizeVideoFromRecorderVideo();
    });

    this.record_player.onended(() => {
      this.maybeSynchronizeVideoFromRecorderVideo();
    });
  }

  maybeSynchronizeVideoFromRecorderVideo(){
    if(this.show_record_player && !this.userStreamIsShown && this.recordedBlobs){
      this.video_player.setCurrentTime(this.recordStartTime + this.record_player.getCurrentTime());
    }
  }

  downloadRecording(){
    const blob = new Blob(this.recordedBlobs, {type: 'video/webm'});
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = 'Loopdance.webm';
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 100);
  }

  maybeShowUserStream(){
    // console.log("maybeShowUserStream");
    // debugger;
    if(!this.userStreamIsShown) this.showUserStream();
  }

  maybePrepareReplay(){
    // console.log("maybePrepareReplay");
    if(this.userStreamIsShown) this.prepareReplay();
  }

  showRecording(){
    if(!this.recording_is_initialized) {
      this.initRecording()
    } else {
      this.finishShowRecording();
    }
  }

  finishShowRecording(){
    this.showUserStream();
    this.show_record_player = true;
    this.record_player.play();
    this.mirror_video = true;
  }

  hideRecording(){
    this.show_record_player = false;
    this.record_player.pause();
    this.forcePauseRecording();
  }

  toggleRecording(){
    // console.log("toggleRecording");
    // this.record_player.player.tech().el().paused is updated too slowly
    // therefore, we keep our own state
    if(this.isRecording){
      this.stopRecording();
      return;
    } else if(this.userStreamIsShown){
      this.playAllVideos();
      return;
    }

    if(this.record_player_is_paused){
      this.playAllVideos();
    } else {
      this.forcePauseRecording();
      this.pauseVideo()
    }
  }

  forcePlayRecording(){
    this.record_player.player.tech().play()
    this.record_player_is_paused = false
  }

  forcePauseRecording(){
    if(this.isRecording) this.stopRecording();
    if(this.userStreamIsShown) return;
    this.record_player.player.tech().el().pause()
    this.record_player_is_paused = true
  }

  pauseRecordVideo(){
    this.record_player.pause();
  }

  pauseAllVideos(){
    this.pauseVideo();
    this.pauseRecordVideo();
  }

  playAllVideos(){
    this.forcePlayRecording();
    this.playVideo();
  }

  pauseVideoOrStopRecording(){
    if(this.isRecording){
      this.stopRecording()
    } else {
      this.pauseAllVideos()
    }
  }

  openExternalLink(link){
    window.open(link, "_blank");
  }

  createSuitableSubSections(section){
    console.log(section)
    if(this.hasMoreThan3Tacts(section)){
      this.createSubSections(section, this.maxCount())
    } else {
      this.createSubSections(section, this.tact_type.counts_per_tact)
    }
  }

  createSmallSectionsUntilTheEnd(section){
    let subsection_content_duration = this.maxCount() * this.config.video.mean_beat_length;

    let start_time = section.start_time;
    let subsection_duration = subsection_content_duration + (3 * this.config.video.mean_beat_length);

    while((start_time + subsection_duration) < this.video_player.getDuration()){
      this.createSubSection(start_time, subsection_duration)
      start_time += subsection_content_duration;
    }
  }

  hasMoreThan3Tacts(section){
    let duration = section.end_time - section.start_time;
    return duration > (3 * this.tact_type.counts_per_tact * this.config.video.mean_beat_length);
  }

  createSubSections(section, content_counts){
    let duration = section.end_time - section.start_time;
    let subsection_content_duration = content_counts * this.config.video.mean_beat_length;
    let full_counts = Math.ceil(duration/subsection_content_duration);

    let i = 0;
    let start_time = section.start_time;
    let subsection_duration = subsection_content_duration + (2 * this.config.video.mean_beat_length);

    while(i < full_counts){
      if((start_time + subsection_duration) > section.end_time){
        subsection_duration = section.end_time - start_time;
      }
      if((start_time + 3*this.config.video.mean_beat_length) > section.end_time) return;

      this.createSubSection(start_time, subsection_duration)

      start_time += subsection_content_duration;
      i += 1;
    }
  }

  createSubSection(start_time, duration){
    let section = {
      name: this.SECTION_DEFAULT_NAME,
      start_time: start_time,
      end_time: start_time + duration,
    };
    this.addSection(section, false);
    this.saveConfig();
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts